import { render, staticRenderFns } from "./GlassDataTable.vue?vue&type=template&id=b0357cde&"
import script from "./GlassDataTable.vue?vue&type=script&lang=js&"
export * from "./GlassDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports